import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ManualCustomerPageRoutingModule } from './manual-customer-routing.module';

import { ManualCustomerPage } from './manual-customer.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ManualCustomerPageRoutingModule
  ],
  declarations: [ManualCustomerPage],
  exports:[ManualCustomerPage]
})
export class ManualCustomerPageModule {}
